import React from 'react';
import { projects } from '../data/resume';
import './Projects.css';

export default function Projects() {
  return (
    <section id="projects" className="section-wrap">
      <h2 className="section-title">Projects</h2>

      {projects.filter(p => p.highlight).map((p) => (
        <div className="project-card project-card--featured" key={p.name}>
          <div className="project-top">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div className="project-icon" style={{ background: p.iconBg }}>{p.icon}</div>
              <span className="live-badge">⬤ LIVE SYSTEM</span>
            </div>
            <div className="project-event mono">{p.event}</div>
          </div>
          <div className="project-name">{p.name}</div>
          <div className="project-desc">{p.desc}</div>
          <div className="project-tags">
            {p.tags.map((t) => (
              <span className="tag mono" key={t}>{t}</span>
            ))}
          </div>
        </div>
      ))}

      <div className="projects-grid">
        {projects.filter(p => !p.highlight).map((p) => (
          <div className="project-card" key={p.name}>
            <div className="project-top">
              <div className="project-icon" style={{ background: p.iconBg }}>{p.icon}</div>
              <div className="project-event mono">{p.event}</div>
            </div>
            <div className="project-name">{p.name}</div>
            <div className="project-desc">{p.desc}</div>
            <div className="project-tags">
              {p.tags.map((t) => (
                <span className="tag mono" key={t}>{t}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
